import { CenterBox } from "../../components/misc/misc.styled";
import { Spacer } from "../../components";
import { LoginContainer } from "./login.styled";
import ConfirmationCodeInput from "./ConfirmationCodeInput";


export const ResetPassword = () => {

  return (
    <LoginContainer>
      <CenterBox
        style={{
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spacer size={4} direction="col" />

        <div className="shadow-lg shadow-gray-400 rounded-lg p-5 w-[500px]">
          <div className="my-6">
            <h1 className="text-center text-3xl font-medium text-blue-500">
              Reset Your Password
            </h1>
          </div>
          <div>
            <h1 className="text-center text-blue-400 my-2">
              Enter Your Verification Code
            </h1>
            <ConfirmationCodeInput/>
          </div>
        </div>

        <Spacer size={1} direction="col" />
      </CenterBox>
    </LoginContainer>
  );
};
